import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ContentPreviewModule } from '../content-preview/content-preview.module';
import { ContentPublicatorModule} from '../content-publicator/content-publicator.module';
import { LoadingModule } from '../loading/loading.module';
import { ContentComponent } from './content/content.component';
import { PlanningComponent } from './planning/planning.component';
import { ContentsLibraryComponent } from './contents-library.component';
import { EditableContentComponent } from './editable-content/editable-content.component';
import { ContentRatingsModule } from './../ratings/content-ratings/content-ratings.module';
import { ContentViewsModule } from './../content-views/content-views.module';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { ContentsLibraryEffects } from './ngrx/effects';
import { reducers } from './ngrx/reducers';
import { ContentsLibraryServices } from './contents-library.services';
import { TagsSelectComponent } from './tags-select/tags-select.component';
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ContentPreviewModule,
    LoadingModule,
    ContentRatingsModule,
    ContentViewsModule,
    StoreModule.forFeature(ContentsLibraryServices.featureName, reducers),
    EffectsModule.forFeature([ContentsLibraryEffects]),
    ContentPublicatorModule
  ],
  declarations: [
    ContentsLibraryComponent,
    ContentComponent,
    PlanningComponent,
    EditableContentComponent,
    TagsSelectComponent
  ],
  exports: [
    ContentsLibraryComponent
  ],
  providers: [
    ContentsLibraryServices
  ]
})
export class ContentsLibraryModule {
}
